import React from "react";
import './PillBar.scss';

export const PillBar = ({ pills }) => {
    return (
        <div className="PillBar">
            {pills}
        </div>
    );
};